import AccessPointShippingForm from './AccessPoint';
export default class UpsShippingForm extends AccessPointShippingForm {
    init() {
        super.init();
        this.settings = {};
        this.initConfig(this.settings);
    }
}